// src/context/AdminProtectedRoute.tsx

import { Navigate, Outlet } from 'react-router-dom';
import { useAppSelector } from '@/store/hooks';

const AdminProtectedRoute = () => {
  const { isAuthenticated, user } = useAppSelector((state) => state.auth);

  if (!isAuthenticated || !user) {
    return <Navigate to="/login" replace />;
  }

  if (user && !user.is_active) {
    return <Navigate to="/suspended" replace />;
  }

  return <Outlet />;
};

export default AdminProtectedRoute;